export default __webpack_public_path__ + "static/L'Architettura-a-Microservizi-81714412b36ffa8f8c9254566b49da8d.jpg";